import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core/styles';
import { FormPresenter } from 'common/hooks';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'reducers';

interface DialogProps {
  open: boolean;
  handleClose: () => void;
  handleClickOpen: () => void;
  selectedContact: number;
  otherContactsForm: FormPresenter<any>;
  duplicatedContactValues: { type: string, value: string }[];
  setDuplicatedContactValues: ([]) => void;
  duplicatedContactFromOtherClient: { type: string, value: string }[];
}

const useStyles = makeStyles(() => ({
	
	dialogContent: {
    width: 300,
    display: 'flex',
		alignItems: 'center',
	},
	
}));

export const ConfirmDeleteDialog = ({open, handleClose, selectedContact, otherContactsForm, duplicatedContactValues, setDuplicatedContactValues, duplicatedContactFromOtherClient }: DialogProps) => {
  const classes = useStyles();
  const { langClientDetail, lang } = useSelector((state: IRootState) => state.locale);
  const doRemove = () => {
    if(otherContactsForm.values.otherContacts.filter((d: { type: any; value: any; }) => d.type == otherContactsForm.values.otherContacts[selectedContact].type && d.value == otherContactsForm.values.otherContacts[selectedContact].value).length <=2
      && !duplicatedContactFromOtherClient.some(d => d.type == otherContactsForm.values.otherContacts[selectedContact].type && d.value == otherContactsForm.values.otherContacts[selectedContact].value)){
      //Don't remove from duplicatedList if there is more then 2 duplicated
      let temp = [...duplicatedContactValues];
      temp = temp.filter(d => d.type !== otherContactsForm.values.otherContacts[selectedContact].type && d.value !== otherContactsForm.values.otherContacts[selectedContact].value);
      setDuplicatedContactValues(temp);
    }
    otherContactsForm.updateValues('otherContacts', otherContactsForm.values.otherContacts.filter((_: any, _i: number) => selectedContact !== _i));
    
    handleClose();
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       
        <DialogContent className={classes.dialogContent}>
          <DialogContentText id="alert-dialog-description">
            {langClientDetail.msgConfirmRemoveContact}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {lang.actionCancel}
          </Button>
          <Button onClick={doRemove} color="primary" variant="contained"  autoFocus>
            {lang.actionConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
